module.exports = __webpack_public_path__ + "img/425-250-mobile.d6f2506.webp";